const members = document.querySelectorAll('.team-members');

for( i=0; i< members.length; i++ ) {
  
    members[i].classList.add('team-members-swiper-container-' + i);

    var slider = new Swiper('.team-members-swiper-container-' + i +' .team-members-list' , {
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.team-members.team-members-swiper-container-' + i + ' .swiper-button-next',
            prevEl: '.team-members.team-members-swiper-container-' + i + ' .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.333,
                spaceBetween: 16
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 16
            }
            
        }
    });

}